import React from 'react';
import { Snackbar, Alert } from '@mui/material';

function FeedbackSnackbar({ open, message, severity, onClose }) {
  return (
    <Snackbar
      open={open}
      autoHideDuration={5000}
      onClose={onClose}
      anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
    >
      <Alert
        onClose={onClose}
        severity={severity}
        variant="filled"
        sx={{
          width: '100%',
          ...(severity === 'success' && {
            backgroundColor: '#388e3c',
            color: '#fff',
            '& .MuiAlert-icon': {
              color: '#fff',
            },
          }),
        }}
      >
        {message}
      </Alert>
    </Snackbar>
  );
}

export default FeedbackSnackbar;
